import { VIEW_PROFILE } from '../../constants';


export function viewProfile() {
    return {
        type: VIEW_PROFILE,
    };
}

